import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/myrequest',
  name: 'myrequest-index',
  component: RouterSection,
  redirect: '/myrequest/list',
  children: [
    {
      path: 'list',
      name: 'myrequest-list',
      component: () => import('@/views/myrequest/MyRequestList.vue'),
      props : true
    },
    {
      path: 'view/temporaryprotection/:receipt_no',
      name: 'myrequest-view-temporaryprotection',
      component: () => import('@/views/myrequest/Temporaryprotection.vue'),
      props : true
    },
    {
      path: 'view/patent/:receipt_no',
      name: 'myrequest-view-patent',
      component: () => import('@/views/myrequest/Patent.vue'),
      props : true
    },
    {
      path: 'view/utilitymodel/:receipt_no',
      name: 'myrequest-view-utilitymodel',
      component: () => import('@/views/myrequest/Utilitymodel.vue'),
      props : true
    },
    {
      path: 'view/ictopography/:receipt_no',
      name: 'myrequest-view-ictopography',
      component: () => import('@/views/myrequest/ICTopography.vue'),
      props : true
    },
    {
      path: 'view/submitmissingdocument/:receipt_no',
      name: 'myrequest-view-submitmissingdocument',
      component: () => import('@/views/myrequest/Submitmissingdocument.vue'),
      props : true
    },
    {
      path: 'view/submitamendment/:receipt_no',
      name: 'myrequest-view-submitamendment',
      component: () => import('@/views/myrequest/Submitamendment.vue'),
      props : true
    },
    {
      path: 'view/voluntaryamendment/:receipt_no',
      name: 'myrequest-view-voluntaryamendment',
      component: () => import('@/views/myrequest/Voluntaryamendment.vue'),
      props : true
    },
    {
      path: 'view/requestappeal/:receipt_no',
      name: 'myrequest-view-requestappeal',
      component: () => import('@/views/myrequest/Requestappeal.vue'),
      props : true
    },
    {
      path: 'view/changenameaddress/:receipt_no',
      name: 'myrequest-view-changenameaddress',
      component: () => import('@/views/myrequest/ChangeNameAddress.vue'),
      props : true
    },
    {
      path: 'view/opposition/:receipt_no',
      name: 'myrequest-view-opposition',
      component: () => import('@/views/myrequest/Opposition.vue'),
      props : true
    },
    {
      path: 'view/restoration/:receipt_no',
      name: 'myrequest-view-restoration',
      component: () => import('@/views/myrequest/Restoration.vue'),
      props : true
    },
    {
      path: 'view/abandonment/:receipt_no',
      name: 'myrequest-view-abandonment',
      component: () => import('@/views/myrequest/Abandonment.vue'),
      props : true
    },
    {
      path: 'view/withdrawal/:receipt_no',
      name: 'myrequest-view-withdrawal',
      component: () => import('@/views/myrequest/Withdrawal.vue'),
      props : true
    },
    {
      path: 'view/changeownership/:receipt_no',
      name: 'myrequest-view-changeownership',
      component: () => import('@/views/myrequest/ChangeOwnership.vue'),
      props : true
    },
    {
      path: 'view/assignchangeagent/:receipt_no',
      name: 'myrequest-view-assignchangeagent',
      component: () => import('@/views/myrequest/AssignChangeAgent.vue'),
      props : true
    },
    {
      path: 'view/registerlicense/:receipt_no',
      name: 'myrequest-view-registerlicense',
      component: () => import('@/views/myrequest/RegisterLicense.vue'),
      props : true
    },
    {
      path: 'view/modifylicense/:receipt_no',
      name: 'myrequest-view-modifylicense',
      component: () => import('@/views/myrequest/ModifyLicense.vue'),
      props : true
    },
    {
      path: 'view/certifiedcopyservice/:receipt_no',
      name: 'myrequest-view-certifiedcopyservice',
      component: () => import('@/views/myrequest/CertifiedCopyService.vue'),
      props : true
    },
    {
      path: 'view/translationandaudit/:receipt_no',
      name: 'myrequest-view-translationandaudit',
      component: () => import('@/views/myrequest/TranslationAndAudit.vue'),
      props : true
    },
    {
      path: 'view/inpersonmeeting/:receipt_no',
      name: 'myrequest-view-inpersonmeeting',
      component: () => import('@/views/myrequest/InPersonMeeting.vue'),
      props : true
    },
    {
      path: 'view/writingandprinting/:receipt_no',
      name: 'myrequest-view-writingandprinting',
      component: () => import('@/views/myrequest/WritingAndPrinting.vue'),
      props : true
    },
    {
      path: 'view/researchservice/:receipt_no',
      name: 'myrequest-view-researchservice',
      component: () => import('@/views/myrequest/ResearchService.vue'),
      props : true
    },
    {
      path: 'view/eserviceconversion/:receipt_no',
      name: 'myrequest-view-eserviceconversion',
      component: () => import('@/views/myrequest/EserviceConversion.vue'),
      props : true
    },
    {
      path: 'view/document/:receipt_no',
      name: 'myrequest-view-document',
      component: () => import('@/views/myrequest/Document.vue'),
      props : true
    }

  ]
}
